import {HPButton} from '@hconnect/uikit/src/lib2'
import {dataTestId} from '@hproduce/suite-core'
import {Upload} from '@mui/icons-material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'
import {useAcceptOptimizedPlan} from '../../hooks'
import {useSelectedOptimizerPlan} from '../../providers/SelectedOptimizerPlanProvider'

export const SendToOptimizedPlanButton = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {visibleScheduleId} = useSelectedOptimizerPlan()
  const {acceptOptimizedPlan} = useAcceptOptimizedPlan()

  const handleAcceptOptimizedPlan = () => {
    if (visibleScheduleId === undefined) {
      throw new Error('Can send optimized plan only if it is selected')
    }
    acceptOptimizedPlan(visibleScheduleId)
  }

  return (
    <HPButton
      size="large"
      variant="contained"
      disabled={visibleScheduleId === undefined}
      startIcon={<Upload fontSize="small" />}
      onClick={handleAcceptOptimizedPlan}
      backgroundMode="medium"
      {...dataTestId('accept_optimized_plan_button')}
    >
      {t('optimizer.sendToProductionPlan')}
    </HPButton>
  )
}
